module.exports = __webpack_public_path__ + "img/GA.557ec47d.png";